import {Component, Injector} from "@angular/core";
import {provideSearchModel} from "@fedeltapointofsale/data-client";
import {
    registerSelectEditControl
} from "../../../framework/entity/edit/edit-controls/select-edit-controls/abstract-select-edit-control.component";
import {ProductLineSearchModel} from "../product-line-search.model";
import {ProductLineSearchPageComponent} from "../product-line-search-page/product-line-search-page.component";
import {ProductLineEditPageComponent} from "../product-line-edit-page/product-line-edit-page.component";
import {
    AbstractSingleSelectEditControlComponent
} from "../../../framework/entity/edit/edit-controls/select-edit-controls/abstract-single-select-edit-control.component";

@Component({
    selector: "wbo-product-line-single-select-edit-control",
    templateUrl: "../../../framework/entity/edit/edit-controls/select-edit-controls/single-select-edit-control.component.html",
    providers: [
        registerSelectEditControl(ProductLineSingleSelectEditControlComponent),
        provideSearchModel(ProductLineSearchModel)
    ]
})
export class ProductLineSingleSelectEditControlComponent extends AbstractSingleSelectEditControlComponent<ProductLineSearchModel> {
    constructor(model: ProductLineSearchModel, injector: Injector) {
        super(model, injector, "sellableId", "name");

        this.extendedSearchComponent = ProductLineSearchPageComponent;
        this.extendedEditComponent = ProductLineEditPageComponent;
    }
}
